import { ContactInfo } from '../common/ContactInfo';

export function InternationalPartner_MyAccount() {
  return <ContactInfo />;
}
